import createSagaMiddleware from 'redux-saga';
import combineSectionReducers from 'combine-section-reducers';
import {
  GlobalPut,
  integrateReduxDevtoolsExtension,
  NgRefreshStore,
  PS20Store,
} from '@ps20-frontend/shop-integration-redux';
import {
  gesamtbeitragMitRabattReducer,
  gesamtbeitragReducerForApp,
  jahresbeitragReducer,
  rabattstufeReducer,
} from '@ps20-frontend/reducers';
import { App } from '@ps20-frontend/frontend-models';
import { configureStore, Dispatch, Middleware, Tuple, UnknownAction } from '@reduxjs/toolkit';
import { rootSaga } from './sagas/rootSaga';

import { rootReducer } from './reducers/rootReducer.reducer';

import { INITIAL_STATE } from './initialState';

import { IAppState } from './appState';
import { versicherungsnehmerReducer } from './reducers/versicherungsnehmer.reducer';
import { transientStateReducer } from './reducers/transient-state.reducer';
import { vorbelegungenReducer } from './reducers/vorbelegungen.reducer';
import { adressvorschlagReducer } from './reducers/adressvorschlag.reducer';
import { risikoortReducer } from './reducers/risikoort.reducer';
import { phVertragsoptionenReducer } from './reducers/vertragsoptionen.reducer';
import { phProduktReducer } from './reducers/produkt.reducer';
import { anzahlWohnungenReducer } from './reducers/anzahl-wohnungen.reducer';
import { vorschaedenReducer } from './reducers/vorschaeden.reducer';
import { antragsnummerReducer } from './reducers/antragsnummer.reducer';
import { phTaasInfoReducer } from './reducers/phTaasInfo.reducer';

export const reducers = combineSectionReducers({
  version: (version: number = null) => version,
  antragsnummer: antragsnummerReducer,
  versicherungsnehmer: versicherungsnehmerReducer,
  transientState: transientStateReducer,
  adressvorschlag: adressvorschlagReducer,
  produkt: phProduktReducer,
  risikoort: risikoortReducer,
  vorbelegungen: vorbelegungenReducer,
  vertragsoptionen: phVertragsoptionenReducer,
  anzahlWohnungen: anzahlWohnungenReducer,
  vorschaeden: vorschaedenReducer,
  taasInfo: phTaasInfoReducer,
  gesamtbeitrag: gesamtbeitragReducerForApp(App.PH),
  jahresbeitrag: jahresbeitragReducer,
  rabattstufe: rabattstufeReducer,
  gesamtbeitragMitRabatt: gesamtbeitragMitRabattReducer,
});

export function storeFactory(initialState: IAppState): PS20Store<IAppState> {
  const ngRefreshStore = new NgRefreshStore<IAppState>(App.PH);
  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    reducer: rootReducer(reducers),
    devTools: integrateReduxDevtoolsExtension('ph-angebot-gui'),
    preloadedState: initialState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(sagaMiddleware, ngRefreshStore.ngRefreshMiddleware) as unknown as Tuple<ReadonlyArray<Middleware<Record<string, never>, IAppState, Dispatch<UnknownAction>>>>,
  });
  sagaMiddleware.run(rootSaga);
  ngRefreshStore.setDelegate(store);
  return ngRefreshStore;
}

export const localStore: PS20Store<IAppState> = storeFactory(INITIAL_STATE);

GlobalPut.getInstance().globalEventDispatcherFunction = () => {
  return localStore.globalEventDispatcherRef;
};
